import React from 'react';
import { isMobile } from 'react-device-detect';
import { ReactComponent as ArtemisSVG } from 'assets/images/dApps/Artemis.svg';
import { ReactComponent as AvalonSVG } from 'assets/images/dApps/Avalon.svg';
import { ReactComponent as GOATswapSVG } from 'assets/images/dApps/GOATswap.svg';
import { ReactComponent as OkuSvg } from 'assets/images/dApps/Oku.svg';
import { ReactComponent as StablejackSVG } from 'assets/images/dApps/Stablejack.svg';
import { ReactComponent as StakestoneSVG } from 'assets/images/dApps/Stakestone.svg';
import { ReactComponent as StargateSVG } from 'assets/images/dApps/Stargate.svg';
import { ReactComponent as NudexSVG } from 'assets/images/dApps/Nudex.svg';
import { ReactComponent as ScoremilkSVG } from 'assets/images/dApps/Scoremilk.svg';

const getIcon = (dAppName: string) => {
    switch (dAppName) {
        case 'Artemis':
            return ArtemisSVG;
        case 'Avalon':
            return AvalonSVG;
        case 'Goatswap':
            return GOATswapSVG;
        case 'Oku':
            return OkuSvg;
        case 'Stablejack':
            return StablejackSVG;
        case 'Stakestone':
            return StakestoneSVG;
        case 'Stargate':
            return StargateSVG;
        case 'Nudex':
            return NudexSVG;
        case 'Scoremilk':
            return ScoremilkSVG;
        default:
            return null;
    }
};

interface DAppIconProps {
    dAppName: string;
    size?: number;
    mobileSize?: number;
}

const DAppIcon = ({ dAppName, size = 30, mobileSize = 20 }: DAppIconProps) => {
    const Icon = getIcon(dAppName);
    return Icon && <Icon width={isMobile ? mobileSize : size} height={isMobile ? mobileSize : size} />;
};

export default DAppIcon;
